import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import RemoveRequisition from '../requisition/RemoveRequisition';
import withWorkflow from '../components/withWorkflow';
import { OrderStatuses } from './OrderStatus';

/**
 * Represents a requisition line item in the order list.
 */
class HistoryItemRequisition extends Component {
	
	/**
	 * Constructor sets up the state and binds the functions.
	 */
	constructor(props) {
		super(props);
		
		this.state = {
			displayRemoveRequisition: false
		}
		
		this.removeClickHandler = this.removeClickHandler.bind(this);
		this.removeRequisitionResponseHandler = this.removeRequisitionResponseHandler.bind(this);
	}
	
	/**
	 * Remove click handler.
	 */
	removeClickHandler() {
		this.setState({
			displayRemoveRequisition: true
		});
	}

	/**
	 * Open the Report PDF in a new window
	 */
	viewResults = (event, accessionNo) => {
		event.preventDefault();
		const url = `${process.env.REACT_APP_GDX_WEB_URL}/mygdx/webreporting/report?orderNo=${accessionNo}&file=/${accessionNo}.pdf`;
		window.open(url, accessionNo, "resizable,scrollbars");
	}
	
	/**
	 * Handles the response from removing a requisition from an order.
	 *
	 * @param response the fetch response
	 */
	removeRequisitionResponseHandler(response) {
		switch (response.status) {
			case 200:
				this.props.removeRequisitionResponseHandler(this.props.requisition.gearRequisitionId, this.props.order.gearOrderId);
				break;
			case 400:
				this.props.setMessage("Sorry, this requisition cannot be removed", "alert-danger");
				break;
			case 403:
				this.props.setMessage("Sorry, you are not authorized to remove this requisition", "alert-danger");
				break;
			case 404:
				this.props.setMessage("Sorry, this requisition cannot be found", "alert-danger");
				break;
			default:
				this.props.setMessage("Sorry, an unexpected error has occcured. If you continue to receive this message, please contact us.", "alert-danger");
		}
	}

	/**
	 * Renders the component.
	 */
	render() {
		let reqPrefix = "";
		if (this.props.requisition.reqNumber) {
			reqPrefix = this.props.requisition.reqNumber;
			if (this.props.requisition.activationCode) {
				// Add hyphen after first 4, and then every 3rd character
				const formattedActivationCode = this.props.requisition.activationCode.match(/(^.{4})|(.{1,3})/g)?.join('-');
				reqPrefix = (
					<>
						<span>{reqPrefix}</span>
						<br />
						<span className="text-nowrap">{formattedActivationCode}</span>
					</>
				);
			}
		} else if (this.props.requisition.shipToOffice && this.props.requisition.quantity ) {
			reqPrefix = "Qty: " + this.props.requisition.quantity;
		}
		let editRoute = 'confirm';
		if (this.props.requisition.shipToOffice) {
			editRoute = 'panels';
		}

		let confirmedShipToOffice = this.props.requisition.shipToOffice && this.props.order.workflow?.practitionerConfirmed;
		let reqProductRetired = this.props.requisition.omsOrderableItemRetiredDate !== null && this.props.requisition.omsOrderableItemRetiredDate < new Date().toString();
		let canEdit = (this.props.status !== OrderStatuses.ACCESSIONED &&
			this.props.status !== OrderStatuses.RESULTS_READY &&
			this.props.status !== OrderStatuses.DISCARDED_SPECIMENS &&
			this.props.status !== OrderStatuses.CANCELED &&
			this.props.status !== OrderStatuses.COMPLETE &&
			!confirmedShipToOffice &&
			this.props.order.workflow.steps.length !== 0) &&
			!reqProductRetired &&
			!this.props.requisition.accessionNo &&
			!this.props.requisition.canceled;
		
		// SCR-6770: Allow delete unless the requisition has been accessioned
		// SCR-7726: Allow delete to be accessible even if edits aren't in the event that the reqproduct is retired
		const canDelete = (canEdit || reqProductRetired) && !this.props.requisition.accessionNo;

		const viewResult = this.props.requisition.accessionNo && (
			<a
				className="btn-link"
				href={`${process.env.REACT_APP_GDX_WEB_URL}/mygdx/webreporting?orderNo=${this.props.requisition.accessionNo}`}
				title="View Results"
				target="_blank"
				rel="noopener noreferrer"
				style={{ whiteSpace: 'nowrap' }}
			>
				{this.props.requisition.accessionNo} <i className="fa fa-external-link"></i>
			</a>
		);

		const star = !!this.props.activeStars.length && (
			<a className='btn-link' href={`${process.env.REACT_APP_GDX_WEB_URL}/mygdx/stars`} title={`${this.props.activeStars.length} unresolved STAR${this.props.activeStars.length > 1 ? 's' : ''}. Click for more detail.`} target='_blank' rel='noopener noreferrer'>
				<i className="fa fa-fw fa-star text-danger"></i>
			</a>);
		
		const reqCanceled = this.props.status !== OrderStatuses.CANCELED && this.props.requisition.canceled;

		return (
			<tr>
				<td className="pull-right" style={{width: "110px"}}>{reqPrefix}</td>
				<td>{this.props.requisition.omsOrderableItemName}</td>
				<td>
					{reqCanceled && <div>Canceled</div>}
					{canEdit &&
						<Link to={"order/" + this.props.order.gearOrderId + "/" + editRoute + "/" + this.props.requisition.gearRequisitionId} title="edit" className="btn-link btn-unstyled condensed">
							<i className="fa fa-fw fa-edit"></i>
						</Link>
					}
					{canDelete &&
							<>
								<button type="button" title="remove" className="btn-link btn-unstyled condensed" data-gearreqid={this.props.requisition.gearRequisitionId} onClick={this.removeClickHandler}><i className="fa fa-fw fa-trash text-danger" /></button>
								{this.state.displayRemoveRequisition && <RemoveRequisition gearOrderId={this.props.order.gearOrderId} requisition={this.props.requisition} removeRequisitionResponseHandler={this.removeRequisitionResponseHandler} modalHidden={() => this.setState({ displayRemoveRequisition: false })} />}
							</>
					}
					{viewResult}
					{star}
				</td>				
			</tr>
		);
	}
}
export default withWorkflow(HistoryItemRequisition);
